import React from "react"

import {FieldViewGroupProps} from "../../../../../render/group/@type"
import TaskTypeIcon from "../../../../../../gd-components/icons/task-icon/task-icon-ui5"

// const debug = "FieldTaskType_ViewGroup"
const debug = false

export default function FieldTaskType_ViewGroup(props: FieldViewGroupProps) {

    const value = props.field.getViewValue(props.model)

    debug && console.log(debug, 'render', value)

    const classes = Classes("flex-row-left-center ui5-txt-less-important ui5-txt-bold", props.className)

    return (
        <div className={classes}>
            {props.showGroupIcon !== false &&
                <div className="flex-row-center-center flex-no-shrink size-22">
                    <TaskTypeIcon taskTypeId={value}/>
                </div>
            }
            <div className="max-w-100-percent txt-truncate view-group-label">{props.field.groupLabel(value, props.groupBy)}</div>
        </div>
    )
}



